import { Assignment, Group } from '@monorepo/shared/src/graph/schema-generated-types-educator';

export type Actions =
  | { type: 'SET_LETTER'; payload: { letter: string } }
  | { type: 'SET_UNSAVED_CHANGES'; payload: { hasUnsavedChanges: boolean } }
  | { type: 'SET_GROUP_FILTER'; payload: { groupFilter: string } }
  | { type: 'SET_SAVE_SUCCESS'; payload: { saveSuccessful: boolean } }
  | { type: 'SET_ASSIGNMENTS'; payload: { assignments: Assignment[] } }
  | { type: 'SET_ALL_GROUPS'; payload: { groups: Group[] } }
  | {
      type: 'SET_SELECTED_GROUPS_AND_STUDENTS';
      payload: {
        selectedGroups: number[];
        selectedStudents: number[];
        hasUnsavedChanges?: boolean;
      };
    };

export type UseAssignmentState = {
  assignments: Assignment[];
  allGroups: Group[];
  selectedGroups: number[];
  selectedStudents: number[];
  hasUnsavedChanges: boolean;
  saveSuccessful: boolean;
  letter: string;
  groupFilter: string;
};

export type UseAssignmentDispatch = {
  handleExit: () => void;
  setAssignments: (assignments: Assignment[]) => void;
  handleEditSave: () => void;
  handleNewAssignmentSave: () => void;
  updateSelectedGroups: (groupId: number) => void;
  setAllGroups: (groups: Group[]) => void;
  setSelectedGroupsAndStudents: () => void;
  updateSelectedStudents: (studentId: number) => void;
  deduplicateStudentsAndGroups: () => number[];
  setLetter: (letter: string) => void;
  setGroupFilter: (groupFilter: string) => void;
  unassignAll: () => void;
};

export enum GroupTypes {
  ALL = 'All',
  PREK = 'Pre-K',
  DEVELOPING = 'Developing',
  EMERGING = 'Emerging',
}

export type UseAssignments = [UseAssignmentState, UseAssignmentDispatch];
